import Vue from "vue"
import Vuex from "vuex"
import api from '@/api/modules/basicData/taskStatistics'

Vue.use(Vuex)

const state = {
	name: 'zrw',
	data: null,
	seven: null,
}

const getters = {
}


const actions = {
	
}

const mutations = {
// 	GetTaskStatisticsByParas(state){
// 		api.GetTaskStatisticsByParas(0).then((res) => {
// 			state.data = res;
// 		})
// 	},
// 	GetTaskTypeList(state){
// 		api.GetTaskTypeList().then((res) => {
// 			state.typeList = res
// 		})
// 	}
	
	
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}